module.exports = __webpack_public_path__ + "media/site/images/ecommerce/ecommerce-tested-solutions.pl@1x-12174d18864b4d387ddd13ba82283894.png";